import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: '', value: 'custom', width: '10'  },
  { text: 'Source Onboarding', value: 'source_onboarding' },
  { text: 'Nama Merchant', value: 'merchant_name' },
  { text: 'Reference No', value: 'reference_number' },
  { text: 'Kode Wilayah', value: 'kode_wilayah'},
  { text: 'Tanggal Pengajuan', value: 'created_at' },
  { text: 'Action', value: 'action', width: '10' },
]);

export const headersList = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Kode Wilayah', value: 'kode_wilayah'},
  { text: 'Wilayah', value: 'nama_wilayah'},
  { text: 'Stock MID', value: 'custom', align: 'center', textAlign: 'text-center' },
  { text: 'Merchant Type', value: 'merchant_type' },
]);

export const headersBulk = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Nama File', value: 'custom'},
  { text: 'Total MID', value: 'total_mid', align: 'center', textAlign: 'text-center'},
  { text: 'Uploaded By', value: 'username'},
  { text: 'Uploaded Date', value: 'created_at'},
  { text: 'Status Upload', value: 'custom_status'},
]);

export const search = {
  sourceOnboarding: '',
  merchantName: '',
  referenceNumber: '',
  areaCode: '',
  createdDate: [],
};

export const listStatus = [
  { text: 'Sukses', value: 1 },
  { text: 'Gagal', value: 0 },
];